import axios from 'axios';
import { saveCurrentReturnPath } from './returnPath';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors - clear invalid tokens
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // If we get a 401 (Unauthorized) and it's not the login endpoint, clear the token
    if (
      error.response?.status === 401 &&
      !error.config.url.includes('/api/login') &&
      !error.config.url.includes('/api/sso-login')
    ) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Preserve intended page (e.g. /create?draft=…) across re-login
      if (window.location.pathname !== '/login' && window.location.pathname !== '/sso') {
        saveCurrentReturnPath();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

